import { Pipe, PipeTransform } from '@angular/core';
import { fill } from 'lodash';

@Pipe({
  name: 'fill',
})
export class FillPipe implements PipeTransform {
  transform(length: number, value: any): any {
    return fill(Array(length), value);
  }
}
